import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './Legal.scss';
import ContentWithPrice from '../UI/Price/ContentWithPrice';

interface ILegalProps {
  context?: IContent;
}

const Legal = ({ context }: ILegalProps) => {
  return (
    <section className="legal">
      {context.footer_legal.map((el, index) => {
        const hasPricePlaceholder = /\<\%PRICE\%\>/.test(el);
        if (hasPricePlaceholder) {
          return (
            <ContentWithPrice
              id={context.uplayplus_productId}
              contentWrapper={el}
              Tag="p"
              key={index}
            />
          );
        }

        return  <p key={index} dangerouslySetInnerHTML={{ __html:el }}/> ;
      })}
    </section>
  );
};

export default withContent(Legal);
